import React, { useEffect, useState } from 'react'
import Table from './Table'
import useWorkCited from '../hooks/use-work-cited.hook'
import { useParams } from 'react-router-dom';
import DeleteWorkCitedPopup from 'features/Collections/components/DeleteWorkCited';
import { Box, Typography } from '@mui/material';

const MainPage = ({setWorkCitedName, setWorkCitedFormatStyle, readOnly = false}) => {
  const [worksCited, setWorksCited] = useState([]);
  const [deletePopup, setDeletePopup] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [loading, setLoading] = useState(true);

  const { getWorkCited, getWorkCitedDocument, deleteWorkCitedDocument } =
    useWorkCited(worksCited, setWorksCited);

    const {id} = useParams();

    const deleteBookmarkSource = async () => {
      await deleteWorkCitedDocument(deleteId);
      setDeletePopup(false);
    }

    useEffect(() => {
      const fetchData = async () => {
        setLoading(true);
        await getWorkCited();
        setLoading(false);
      }
      fetchData();
    }, [id])

  return (
    <React.Fragment>
      {(!loading && worksCited.length === 0) ?
      <Box sx={{mt: 4, display: "flex", alignItems: "center", justifyContent: "center"}}>
        <Typography color="grey.600">
          {readOnly
            ? "This student hasn't added any Works Cited to this collection."
            : "Click the create button to get started with a new Works Cited."}
        </Typography>
      </Box> :
      <Table
        rows={worksCited}
        getWorkCitedDocument={getWorkCitedDocument}
        setWorkCitedName={setWorkCitedName}
        setWorkCitedFormatStyle={setWorkCitedFormatStyle}
        setDeleteId={setDeleteId}
        setDeletePopup={setDeletePopup}
        readOnly={readOnly}
        loading={loading}
      />
}
      {deletePopup && (
        <DeleteWorkCitedPopup
          deletePopup={deletePopup}
          setDeletePopup={setDeletePopup}
          deleteBookmarkSource={deleteBookmarkSource}
        />
      )}
    </React.Fragment>
  );
}

export default MainPage
